import React from 'react';
import { bool, shape, string } from 'prop-types';

const Check = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.79508 15.8769L4.62508 11.7069L3.20508 13.1169L8.79508 18.7069L20.7951 6.70687L19.3851 5.29688L8.79508 15.8769Z" fill="currentColor" />
  </svg>
);

Check.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Check;
